import { put, takeEvery, takeLatest, delay } from "redux-saga/effects";
import {
  SET_LOADER_STATUS,
  FINISH_LOADER,
  START_LOADER
} from "./loader.action";

function* startLoader({ payload }) {
  yield put({
    type: SET_LOADER_STATUS,
    payload: {
      isLoading: true,
      name: payload
    }
  });
}
function* finishLoader({ payload }) {
  yield delay(300);
  yield put({
    type: SET_LOADER_STATUS,
    payload: {
      isLoading: false,
      name: payload
    }
  });
}

export default function* loaderSaga() {
  yield takeEvery(START_LOADER, startLoader);
  yield takeLatest(FINISH_LOADER, finishLoader);
}
